import { FC, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { ButtonPromo, TextPromo } from 'components/ui'
import { Space } from 'components/ui/Space/Space'
import { sendAdriverEvent } from 'utils/adriver/sendAdriverEvent'
import { sendEvent } from 'utils/helpers/sendEvent'
import { useResize } from 'utils/hooks/useResize'
import { PromoRoutesEnum } from 'shared/constants/routes'
import { AdriverEventType, EventType } from 'types/types'

import { FaqItem } from './components/FaqItem'
import { questionAnswers, simplifiedQuestionAnswers } from './data'
import { QAItem } from './types'

import s from './Faq.module.scss'

const Faq: FC = () => {
  const [showAll, setShowAll] = useState<boolean>(false)
  const [selectedQuestion, setSelectedQuestion] = useState<string>()
  const location = useLocation()

  const { isMobile, isDesktop, isTablet } = useResize()

  const isSimplified = location.pathname === PromoRoutesEnum.simplifiedConditions
  const questionsData = isSimplified ? simplifiedQuestionAnswers : questionAnswers
  const questionsPart = (questionsData as QAItem[])?.slice(0, 5)
  const questionsAll = questionsData as QAItem[]

  const questions = showAll ? questionsAll : questionsPart

  const handleSelect = (question: string) => {
    if (question === selectedQuestion) {
      setSelectedQuestion(undefined)
    } else {
      setSelectedQuestion(question)
      sendEvent(EventType.FAQElementT, { question, location: isSimplified ? 'Упрощённые условия' : 'Главная' })
    }
  }

  const toggleShowAll = () => {
    setShowAll((prev) => !prev)
    sendAdriverEvent(AdriverEventType.allQuestions)
  }

  return (
    <section className={s.section}>
      <div id="faq" className={`contentWrapper ${s.faqSection}`}>
        <Space size={!isTablet ? 140 : 80} />
        <div className={s.title}>
          <TextPromo center weight="w700" size={isMobile ? 's32' : isTablet ? 's40' : isDesktop ? 's70' : 's70'}>
            Вопросы и ответы
          </TextPromo>
        </div>

        <Space size={20} />

        <div className={s.questions}>
          {questions.map((q, index) => (
            <FaqItem key={index} onClick={() => handleSelect(q.q)} question={q} />
          ))}

          <Space size={isMobile ? 24 : 60} />

          <ButtonPromo onClick={toggleShowAll} fullWidth className={s.button}>
            <TextPromo pointer fontFamily="ASLHaussVF" size={isTablet ? 's16' : 's20'} color="white">
              {showAll ? 'Скрыть список' : 'Все вопросы и ответы'}
            </TextPromo>
          </ButtonPromo>
        </div>
      </div>
    </section>
  )
}

export default Faq
